import {
    GETWAYLIST_SUCCESS,
    GETWAYLIST_FAILED,
    RESET_GETWAYLIST,
    LOADING_GETWAYLIST,
    NETWORK_ERROR_GETWAYLIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetWayList = () => {
    return { type: RESET_GETWAYLIST };
};

const getWayList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETWAYLIST });
    await adminServices
        .post("getWayList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getWayListsuccess(res.data));
                    break;
                default:
                    dispatch(getWayListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETWAYLIST, payload: err });
        });
};
function getWayListsuccess(data) {
    return {
        type: GETWAYLIST_SUCCESS,
        payload: data,
    };
}
function getWayListFailed(data) {
    return {
        type: GETWAYLIST_FAILED,
        payload: data,
    };
}

export { resetGetWayList, getWayList };